import axios from '@/axios';

const RESOURCE_NAME = '/admin/ai-sequences';

export default {
    getList(data) {
        return axios.post(`${RESOURCE_NAME}/get-list`, data)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },

    getLogs(data) {
        return axios.post(`${RESOURCE_NAME}/get-logs`, data)
    },
}
